<script>
import InfiniteTraderAndLocationAutoComplete from "@/driver/components/InfiniteTraderAndLocationAutoComplete.vue";
import InfiniteTransportRouteAutoComplete from "@/driver/components/InfiniteTransportRouteAutoComplete.vue";
import InfiniteEmissionAndLocationAutoComplete from "@/driver/components/InfiniteEmissionAndLocationAutoComplete.vue";
import ChooseEmissionModal from "@/driver/components/ChooseEmissionModal.vue";
import RegisterConditionPatternModal from "../../../components/RegisterConditionPatternModal.vue";
import Confirm from "@/components/Confirm.vue";
import ChooseTraderModal from "@/driver/components/ChooseTraderModal.vue";

export default {
  name: "OrderAcceptSearchBlock",
  components: {
    InfiniteTraderAndLocationAutoComplete, ChooseTraderModal,
    Confirm,
    ChooseEmissionModal,
    InfiniteEmissionAndLocationAutoComplete,
    InfiniteTransportRouteAutoComplete,
    RegisterConditionPatternModal,
  },
  mixins: [

  ],
  props: {
    /* 検索条件 */
    conditions: {
      type: Object,
      default: () => {},
    },
    /* 検索パターン */
    conditionPatterns: {
      type: Array,
      default: () => [],
    },
    /* 選択中の検索パターン */
    selectableConditionPattern: {
      type: Number,
      default: 0,
    },
    drivers: {
      type: Array,
      default: () => [],
    },
    voteStaffs: {
      type: Array,
      default: () => [],
    },
    isBilling: {
      type: Boolean,
      default: false,
    },
    stopSearch: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showEmissionModal: false,
      showTraderModal: false,
      showRegisterConditionPatternModal: false,
      /** 受注種別 */
      orderTypes: [
        { value: "collection", text: "産廃回収" },
        { value: "self_emission", text: "排出持込" },
        { value: "proxy_request", text: "他社運搬" },
        { value: "general", text: "一廃回収" },
        { value: "carryin", text: "積替運搬" },
        { value: "pickup", text: "搬入予約" },
      ],
      /** 回収日の状態 */
      collectedDateTypes: [
        { value: "anytime", text: "指定なし" },
      ],
      /** 排出者承認 */
      approvalStatus: [
        // { value: 'before_reserve', code: 'ー', text: '予約前' },
        { value: 'await_approval', code: '▲', text: '未承認' },
        { value: 'before_registered', code: '●', text: '承認済（本登録前）' },
        { value: 'after_registered', code: '●', text: '承認済（本登録済）' },
        { value: 'remand', code: '×', text: '差戻' },
        { value: 'none_use_approval', code: '　', text: '対象外' },
      ],
      /** 依頼番号有無 */
      requestNumberFlags: [
        { value: "something", text: "有" },
        { value: "nothing", text: "無" },
      ],
      /** 取引番号有無 */
      dealNumberFlags: [
        { value: "something", text: "有" },
        { value: "nothing", text: "無" },
        { value: "not_sales", text: "計上しない" },
      ],
      /** マニフェスト区分 */
      manifestTypes: [
        { value: "dxe_form", text: "電子マニフェスト(EDI)" },
        { value: "other_form", text: "電子マニフェスト(WEB)" },
        { value: "paper_form", text: "紙マニフェスト" },
        { value: "general_form", text: "一般廃棄物" },
      ],
      /** 表示順 */
      sortTypes: [
        { value: 'updated_date_desc', text: '更新日（降順）▼' },
        { value: 'updated_date_asc', text: '更新日（昇順）▲' },
        { value: 'created_date_desc', text: '作成日（降順）▼' },
        { value: 'created_date_asc', text: '作成日（昇順）▲' },
        { value: 'target_date_desc', text: '回収・積替・搬入日（降順）▼' },
        { value: 'target_date_asc', text: '回収・積替・搬入日（昇順）▲' },
      ],

    }
  },
  computed: {
    currentTabIndex() {
      return this.selectableConditionPattern;
    },
  },
  watch: {},
  mounted() {
    // 最初はハンドラを無効化
    this.handleTabChange = () => {};

    this.$nextTick(() => {

      if (this.$refs.tabs) {
        this.$refs.tabs.internalValue = this.currentTabIndex;
      }

      // 本来のハンドラを復元
      this.handleTabChange = this.realHandleTabChange;
    });
  },
  methods: {
    realHandleTabChange(newIndex) {
      if (newIndex === 0) {
        this.$emit("update:selectableConditionPattern", newIndex);
        this.$emit("userTabChange", newIndex);  // ユーザー操作を通知
        return;
      }
      if (newIndex === this.selectableConditionPattern) return;

      this.$emit("update:selectableConditionPattern", newIndex);
      this.$emit("userTabChange", newIndex);  // ユーザー操作を通知
    },
    handleTabChange(newIndex) {
      // mountedで上書きされるダミー
    },
    /**
     * 取引先（排出）事業者 モーダル表示
     */
    showEmissionModalButtonClickEvent() {
      this.showEmissionModal = true;
    },
    showTraderModalButtonClickEvent() {
      this.showTraderModal = true;
    },
    /**
     * 削除ボタン クリックイベント
     * 確認メッセージを表示.
     * 指定タブを削除
     * 全項目に切替
     */
    removeTabButtonClickEvent () {
      if (this.selectableConditionPattern === 0) {
        return
      }
      this.$refs.confirm.showDeleteConfirm().then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.$emit('removeConditionPattern', this.selectableConditionPattern)
        }
      })
    },
    /**
     * クリアボタン クリックイベント
     * 入力内容をクリアする
     */
    clearButtonClickEvent() {
      this.$emit("clear", this.selectableConditionPattern)
    },
    searchButtonClickEvent () {
      this.$emit("search");
    },
    addTabButtonClickEvent() {
      this.showRegisterConditionPatternModal = true;
    },

    transportUserChangeEvent(driver_id) {
      let driver = this.drivers.find((v) => v.value === driver_id);
      if (driver) {
        this.conditions.report_transport_user_name = driver.text
      }
      this.handleSearch();
    },
    driverChangeEvent(driver_id) {
      let driver = this.drivers.find((v) => v.value === driver_id);
      if (driver) {
        this.conditions.driver_name = driver.text
      }
      this.handleSearch();
    },
    /**
     * 回収先（排出事業者・事業場） チェンジコールバック
     *
     * @param emission_id { Number } 排出事業者ID
     * @param location_id { Number } 排出事業場ID
     * @param location_code { String } 排出事業場コード
     */
    supplierChangeCallback (emission_id, location_id, location_code) {
      let changed = false;
      if (this.conditions.supplier_id !== emission_id) {
        changed = true;
      }

      if (this.conditions.supplier_location_id !== location_id) {
        changed = true;
      }

      this.conditions.supplier_id = emission_id;
      this.conditions.supplier_type = emission_id ? "Emission" : null;
      this.conditions.supplier_location_id = location_id;
      this.conditions.supplier_location_code = location_code;

      if (changed) {
        this.$nextTick(() => { this.handleSearch(); })
      }
    },
    /**
     * 排出事業者選択モーダル　コールバック
     * @param item
     */
    choseSupplierCallback(item) {
      this.conditions.supplier_id = item.id;
      this.conditions.supplier_type = item.type;
      this.conditions.supplier_location_id = null;
      this.conditions.supplier_location_code = null;
      this.$nextTick(() => { this.handleSearch(); })
      this.closeDialog();
    },
    /**
     * 回収先 収運・処分チェンジ コールバック
     * @param trader_id
     * @param location_id
     * @param location_code
     */
    supplierTraderChangeCallback (trader_id, location_id, location_code) {
      let changed = false;
      if (this.conditions.supplier_trader_id !== trader_id) {
        changed = true;
      }
      if (this.conditions.supplier_trader_location_id !== location_id) {
        changed = true;
      }
      this.conditions.supplier_trader_id = trader_id;
      this.conditions.supplier_trader_type = trader_id ? "Trader" : null;
      this.conditions.supplier_trader_location_id = location_id;
      this.conditions.supplier_trader_location_code = location_code;

      if (changed) {
        this.$nextTick(() => { this.handleSearch(); })
      }
    },
    /**
     * 収運・処分業者選択モーダル コールバック
     * @param item
     */
    choseTransportCallback(item) {
      this.conditions.supplier_trader_id = item.id;
      this.conditions.supplier_trader_location_id = null;
      this.conditions.supplier_trader_location_code = null;
      this.conditions.supplier_trader_type = 'Trader'
      this.$nextTick(() => { this.handleSearch(); })
      this.closeDialog();
    },
    /**
     * 運搬ルートチェンジ コールバック
     * @param route_id
     */
    transportRouteChangedCallback (route_id) {
      this.conditions.transport_route_id = route_id;
      this.$nextTick(() => { this.handleSearch(); })
    },
    /**
     * 回収・積替・搬入日（From）変更　コールバック
     */
    collectedStartDateChangedCallback (value) {
      this.conditions.collected_start_date = value;
      this.handleSearch();
    },
    /**
     * 回収・積替・搬入日（To）変更　コールバック
     */
    collectedEndDateChangedCallback (value) {
      this.conditions.collected_end_date = value;
      this.handleSearch();
    },
    /**
     * 検索パターン登録 コールバック
     * @param item { Object } 検索パターン
     */
    registerConditionPatternCallback (item) {
      this.$emit("addConditionPattern", item)
      this.closeDialog();
    },
    handleSearch () {
      if (!this.stopSearch) {
        this.searchButtonClickEvent();
      }
    },
    /**
     * 各種クリアボタン クリックイベント
     * @param keys { String, Array } プロパティ名
     */
    clearEvent (keys) {
      if (Array.isArray(keys)) {
        keys.forEach(key => this.conditions[key] = null);
      } else {
        this.conditions[keys] = null;
      }
      this.handleSearch();
    },

    closeDialog() {
      this.showEmissionModal = false;
      this.showTraderModal = false
      this.showRegisterConditionPatternModal = false;
    },
    chipColor (item) {
      let color = null
      switch (item.value) {
        case 'await_approval':
          color = '#F0C000'
          break
        case 'before_registered':
          color = '#f57c00'
          break
        case 'after_registered':
          color = '#0074BA'
          break
        case 'none_use_approval':
          color = ''
          break
        case 'remand':
          color = 'red'
          break
        default:
      }
      return color
    },
  }
}
</script>

<template>
  <div class="search-block">
    <v-expansion-panels accordion>
      <v-expansion-panel>
        <v-expansion-panel-header
          class="panel-header-color panel-selectable"
        >
          <strong>
            <v-icon class="panel-header-color"> mdi-magnify </v-icon>
            &nbsp;条件を指定して検索
          </strong>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card v-if="conditions" flat light>
            <v-card-text class="pt-0">

              <v-layout class="mb-2">
                <v-flex style="width: 80%" class="py-0">
                  <v-tabs
                    :value="currentTabIndex"
                    ref="tabs"
                    align-with-title
                    show-arrows
                    :key="`tabs-${conditionPatterns.length}`"
                    @change="handleTabChange"
                  >
                    <v-tab
                    >
                      全項目
                    </v-tab>
                    <v-tab
                      v-for="(tab, index) in conditionPatterns"
                      :key="index"
                    >
                      {{ tab.name }}
                    </v-tab>
                  </v-tabs>
                </v-flex>
                <v-flex shrink class="align-self-center">
                  <v-btn color="primary" @click="addTabButtonClickEvent"
                  >検索パターン追加<v-icon>mdi-plus</v-icon></v-btn
                  >
                </v-flex>
              </v-layout>

              <!-- 取引先（排出）事業者, 取引先（排出）事業場, 運搬担当者 -->
              <infinite-emission-and-location-auto-complete
                :supplier-id="conditions.supplier_id"
                :location-id="conditions.supplier_location_id"
                :location-code="conditions.supplier_location_code"
                :without-general-form="false"
                :uncontrol-disabled="true"
                classes="search-font"
                supplier-md="5"
                location-md="4"
                supplier-label="取引先（排出事業者）"
                location-label="取引先事業場"
                rounded
                @update:values="supplierChangeCallback"
              >
                <template v-slot:supplier-append-outer>
                  <v-btn
                    class="primary"
                    small
                    @click="showEmissionModalButtonClickEvent"
                  >
                    取引先を選択
                  </v-btn>
                  <choose-emission-modal
                    :enable="showEmissionModal"
                    :without-general-form="false"
                    @selected="choseSupplierCallback"
                    @close="closeDialog"
                  />
                </template>
                <template v-slot:location-item="slotProps">
                  <v-chip
                    :title="slotProps.item?.code"
                    color="#e0ffff"
                    label
                    small
                  >
                    {{ slotProps.item?.code }}
                  </v-chip>
                  &nbsp;{{ slotProps.item.text }}
                  <small class="text--disabled">{{ slotProps.item.address }}</small>
                </template>
                <template v-slot:append>
                  <v-col cols="12" md="3">
                    <v-select
                      v-model="conditions.report_transport_user_id"
                      :items="drivers"
                      class="search-font"
                      clearable
                      dense
                      hide-details="auto"
                      label="運搬担当者"
                      outlined
                      rounded
                      persistent-placeholder
                      @change="transportUserChangeEvent"
                      @click:clear="clearEvent('report_transport_user_name')"
                    />
                  </v-col>
                </template>
              </infinite-emission-and-location-auto-complete>
              <!-- /取引先, 取引先事業場, 運搬担当者 -->

              <!-- 運搬先（収運・処分）事業者, 運搬先（収運・処分）事業場 -->
              <infinite-trader-and-location-auto-complete
                :trader-id="conditions.supplier_trader_id"
                :location-id="conditions.supplier_trader_location_id"
                :location-code="conditions.supplier_trader_location_code"
                :include-general-waste-disposer="true"
                classes="search-font"
                trader-md="5"
                location-md="4"
                trader-label="運搬先（収運・処分事業者）"
                location-label="運搬先事業場"
                rounded
                search-type="either"
                @update:values="supplierTraderChangeCallback"
              >
                <template v-slot:location-item="slotProps">
                  <v-chip
                    :title="slotProps.item?.code"
                    color="#e0ffff"
                    label
                    small
                  >
                    {{ slotProps.item?.code }}
                  </v-chip>
                  &nbsp;{{ slotProps.item.text }}
                  <small class="text--disabled">{{ slotProps.item.address }}</small>
                </template>
                <template v-slot:trader-append-outer>
                  <v-btn
                    color="primary"
                    small
                    @click="showTraderModalButtonClickEvent"
                  >
                    運搬先を選択
                  </v-btn>
                  <choose-trader-modal
                    :enable="showTraderModal"
                    :include-general-waste-disposer="true"
                    @close="closeDialog"
                    @selected="choseTransportCallback"
                  />
                </template>
              </infinite-trader-and-location-auto-complete>
              <!-- /運搬先（収運・処分）事業者, 運搬先（収運・処分）事業場 -->

              <!-- 受注種別, 回収・積替・搬入日（From）, 回収・積替・搬入日（To）, 回収日なし -->
              <v-row>
                <!-- 受注種別 -->
                <v-col cols="12" md="2">
                  <v-select
                    v-model="conditions.order_type"
                    :items="orderTypes"
                    clearable
                    dense
                    hide-details="auto"
                    label="受注種別"
                    outlined
                    persistent-placeholder
                    rounded
                    style="font-size: 80%"
                    @change="searchButtonClickEvent()"
                  />
                </v-col>
                <!-- /受注種別 -->

                <!-- 回収・積替・搬入日（From） -->
                <v-col cols="12" md="2">
                  <cs-date-picker
                    :date.sync="conditions.collected_start_date"
                    @dateChangedCallback="collectedStartDateChangedCallback"
                  >
                    <template v-slot="{ on, attrs }">
                      <v-text-field
                        v-model="conditions.collected_start_date"
                        v-bind="attrs"
                        v-on="on"
                        append-icon="mdi-calendar"
                        clearable
                        dense
                        hide-details="auto"
                        label="回収・積替・搬入日（From）"
                        outlined
                        persistent-placeholder
                        placeholder="日付を選択"
                        readonly
                        rounded
                        style="font-size: 80%"
                        @click:clear="clearEvent(['collected_start_date', 'target_date', 'plan_date'])"
                      >
                        <template v-slot:append-outer>
                          <div
                            v-if="$vuetify.breakpoint.mdAndUp"
                            style="vertical-align: middle"
                          >
                            〜
                          </div>
                        </template>
                      </v-text-field>
                    </template>
                  </cs-date-picker>
                </v-col>
                <!-- /回収・積替・搬入日（From） -->

                <!-- 回収・積替・搬入日（To） -->
                <v-col cols="12" md="2">
                  <cs-date-picker
                    :date.sync="conditions.collected_end_date"
                    @dateChangedCallback="collectedEndDateChangedCallback"
                  >
                    <template v-slot="{ on, attrs }">
                      <v-text-field
                        v-model="conditions.collected_end_date"
                        v-bind="attrs"
                        v-on="on"
                        append-icon="mdi-calendar"
                        clearable
                        dense
                        hide-details="auto"
                        label="回収・積替・搬入日（To）"
                        outlined
                        persistent-placeholder
                        placeholder="日付を選択"
                        readonly
                        rounded
                        style="font-size: 80%"
                        @click:clear="clearEvent(['collected_end_date', 'target_date', 'plan_date'])"
                      />
                    </template>
                  </cs-date-picker>
                </v-col>
                <!-- /回収・積替・搬入日（To） -->

                <!-- 回収日なし -->
                <v-col cols="12" md="2">
                  <v-select
                    v-model="conditions.collected_date_type"
                    :items="collectedDateTypes"
                    background-color="white"
                    clearable
                    dense
                    hide-details="auto"
                    label="回収日なし"
                    outlined
                    persistent-placeholder
                    rounded
                    style="font-size: 80%"
                    @change="handleSearch"
                  >
                  </v-select>
                </v-col>
                <!-- /回収日なし -->

              </v-row>
              <!-- /受注種別, 回収日(from), 回収日(to), 回収日なし -->

              <!-- 受注番号, 依頼番号有無, 依頼番号, 取引番号有無, 取引番号 -->
              <v-row>

                <!-- 受注番号 -->
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="conditions.order_number"
                    background-color="white"
                    dense
                    hide-details="auto"
                    label="受注番号"
                    outlined
                    rounded
                    persistent-placeholder
                    clearable
                    style="font-size: 80%"
                    @blur="handleSearch"
                    @click:clear="clearEvent('order_number')"
                  />
                </v-col>
                <!-- /受注番号 -->

                <!-- 依頼番号有無 -->
                <v-col cols="12" md="2">
                  <v-select
                    v-model="conditions.request_number_flag"
                    :items="requestNumberFlags"
                    dense
                    hide-details="auto"
                    label="依頼番号有無"
                    clearable
                    outlined
                    persistent-placeholder
                    rounded
                    style="font-size: 80%"
                    @change="handleSearch"
                  />
                </v-col>
                <!-- /依頼番号有無 -->

                <!-- 依頼番号 -->
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="conditions.request_number"
                    clearable
                    dense
                    hide-details="auto"
                    label="依頼番号"
                    outlined
                    persistent-placeholder
                    rounded
                    style="font-size: 80%"
                    @blur="handleSearch"
                    @click:clear="clearEvent('request_number')"
                  />
                </v-col>
                <!-- /依頼番号 -->

                <!-- 取引番号有無 -->
                <v-col
                  v-if="isBilling"
                  cols="12"
                  md="2"
                >
                  <v-select
                    v-model="conditions.deal_number_flag"
                    :items="dealNumberFlags"
                    clearable
                    dense
                    hide-details="auto"
                    label="取引番号有無"
                    outlined
                    persistent-placeholder
                    rounded
                    style="font-size: 80%"
                    @change="handleSearch"
                  />
                </v-col>
                <!-- /取引番号有無 -->

                <!-- 取引番号 -->
                <v-col v-if="isBilling" cols="12" md="2">
                  <v-text-field
                    v-model="conditions.deal_number"
                    clearable
                    background-color="white"
                    dense
                    hide-details="auto"
                    label="取引番号"
                    outlined
                    persistent-placeholder
                    rounded
                    style="font-size: 80%"
                    @blur="handleSearch"
                    @click:clear="clearEvent('deal_number')"
                  />
                </v-col>
                <!-- /取引番号 -->

              </v-row>
              <!-- /受注番号, 依頼番号有無, 依頼番号, 取引番号有無, 取引番号 -->

              <!-- マニフェスト区分, DXE起票担当者, 排出事業場コード, 排出事業場名称, 廃棄物の名称 -->
              <v-row>

                <v-col cols="12" md="3">
                  <v-select
                    v-model="conditions.manifest_type"
                    :items="manifestTypes"
                    clearable
                    dense
                    hide-details="auto"
                    label="マニフェスト区分"
                    outlined
                    persistent-placeholder
                    rounded
                    style="font-size: 80%"
                    @change="handleSearch"
                  />
                </v-col>

                <v-col cols="12" md="2">
                  <v-combobox
                    v-model="conditions.vote_staff"
                    :items="voteStaffs"
                    :return-object="false"
                    dense
                    label="DXE起票担当者"
                    hide-details="auto"
                    outlined
                    rounded
                    clearable
                    persistent-placeholder
                    style="font-size: 80%"
                    @change="handleSearch"
                  />
                </v-col>

                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="conditions.location_code"
                    class="search-font"
                    clearable
                    dense
                    hide-details="auto"
                    label="排出事業場コード"
                    outlined
                    persistent-placeholder
                    placeholder="例）K001"
                    rounded
                    @blur="handleSearch"
                    @click:clear="clearEvent('location_code')"
                  />
                </v-col>

                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="conditions.location_name"
                    class="search-font"
                    clearable
                    dense
                    hide-details="auto"
                    label="排出事業場名称"
                    outlined
                    persistent-placeholder
                    placeholder="部分一致で検索"
                    rounded
                    @blur="handleSearch"
                    @click:clear="clearEvent('location_name')"
                  />
                </v-col>

                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="conditions.waste_name"
                    background-color="white"
                    dense
                    hide-details="auto"
                    label="廃棄物の名称"
                    outlined
                    rounded
                    persistent-placeholder
                    clearable
                    style="font-size: 80%"
                    @blur="handleSearch"
                    @click:clear="clearEvent('waste_name')"
                  />
                </v-col>

              </v-row>
              <!-- /マニフェスト区分, DXE起票担当者, 排出事業場コード, 排出事業場名称, 廃棄物の名称 -->

              <!-- 運搬先, ルート, 検索キーワード, マニフェスト検索キーワード -->
              <v-row>

                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="conditions.keyword"
                    clearable
                    dense
                    hide-details="auto"
                    label="運搬先"
                    outlined
                    placeholder="運搬先を検索"
                    persistent-placeholder
                    rounded
                    style="font-size: 80%"
                    @blur="handleSearch"
                    @click:clear="clearEvent('keyword')"
                  />
                </v-col>

                <v-col cols="12" md="3">
                  <infinite-transport-route-auto-complete
                    :transport-route-id="conditions.transport_route_id"
                    classes="search-font"
                    general
                    first-trader-owned
                    self-emission
                    self-emission-include_own
                    proxy-request
                    rounded
                    @update:values="transportRouteChangedCallback"
                  />
                </v-col>

                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="conditions.search_keyword"
                    dense
                    hide-details="auto"
                    label="検索キーワード"
                    outlined
                    rounded
                    persistent-placeholder
                    clearable
                    style="font-size: 80%"
                    @blur="handleSearch"
                    @click:clear="clearEvent('search_keyword')"
                  />
                </v-col>

                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="conditions.manifest_search_keyword"
                    class="search-font"
                    clearable
                    dense
                    hide-details="auto"
                    label="マニフェスト検索キーワード"
                    outlined
                    persistent-placeholder
                    persistent-hint
                    rounded
                    @blur="handleSearch"
                    @click:clear="clearEvent('manifest_search_keyword')"
                  />
                </v-col>

              </v-row>
              <!-- /運搬先, ルート, 検索キーワード, マニフェスト検索キーワード -->

              <!-- 排出者承認, ドライバー, 表示順 -->
              <v-row>

                <v-col cols="12" md="2">
                  <v-select
                    v-model="conditions.approval_state"
                    :items="approvalStatus"
                    clearable
                    background-color="white"
                    dense
                    hide-details="auto"
                    label="排出者承認"
                    outlined
                    persistent-placeholder
                    rounded
                    style="font-size: 80%"
                    @change="handleSearch"
                  >
                    <template v-slot:item="slotProps" >
                      <v-chip
                        :title="slotProps.item.code"
                        :text-color="chipColor(slotProps.item)"
                        label
                        small
                        style="background-color: rgba(0, 0, 0, 0);"
                      >
                        {{ slotProps.item.code }}
                      </v-chip>&nbsp;
                      <div style="font-size: 80%">{{slotProps.item.text}}&nbsp;</div>
                    </template>
                  </v-select>
                </v-col>

                <v-col cols="12" md="3">
                  <v-select
                    v-model="conditions.driver_id"
                    :items="drivers"
                    clearable
                    dense
                    hide-details="auto"
                    label="ドライバー"
                    outlined
                    rounded
                    persistent-placeholder
                    style="font-size: 80%"
                    @change="driverChangeEvent"
                  />
                </v-col>

                <v-col cols="12" md="2">
                  <v-select
                    v-model="conditions.sort_type"
                    :items="sortTypes"
                    dense
                    hide-details="auto"
                    label="表示順"
                    outlined
                    persistent-placeholder
                    rounded
                    style="font-size: 80%"
                    @change="handleSearch"
                  />
                </v-col>

              </v-row>
              <!-- /排出者承認, ドライバー, 表示順 -->

            </v-card-text>
            <v-card-actions>
              <v-btn
                v-if="currentTabIndex > 0"
                color="error"
                @click="removeTabButtonClickEvent"
              >
                削除
              </v-btn>
              <v-spacer />
              <v-btn
                @click="clearButtonClickEvent"
              >
                &emsp;クリア&emsp;
              </v-btn>

              <v-btn color="primary" @click="searchButtonClickEvent">
                <v-icon> mdi-magnify </v-icon>
                &nbsp;検索
              </v-btn>

            </v-card-actions>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <register-condition-pattern-modal
      :enable="showRegisterConditionPatternModal"
      :conditions.sync="conditions"
      classification="orders"
      @close="closeDialog"
      @register="registerConditionPatternCallback"
    />
    <confirm ref="confirm" />

  </div>
</template>
